import * as React from "react";
import robot from "@assets/robot2.png";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, Grid } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import robot2x from "@assets/gears_bot_2x.png";

interface Props {
  text: string | undefined;
  isError?: boolean;
  size?: 1 | 2 | undefined;
}

const useStyles = makeStyles({
  container: {
    flexDirection: "column",
    flexGrow: 1,
  },
  text: {
    margin: "0 auto",
  },
  robot: {
    margin: "0 auto",
  },
  errorIcon: {
    align: "center",
  },
});

export const Robot: React.FC<Props> = ({ text, isError, size = 1 }) => {
  const classNames = useStyles();

  return (
    <Box className={classNames.container}>
      <Grid container direction="row" justify="center">
        <Grid item>
          <Box mb={2} hidden={!isError}>
            <FontAwesomeIcon icon={faExclamationCircle} color="red" size="2x" />
          </Box>
        </Grid>
        <Grid item>
          <Box className={classNames.text}>
            <Typography
              variant="body1"
              color={isError ? "error" : "textPrimary"}
              paragraph
            >
              {text}
            </Typography>
          </Box>
          <Box className={classNames.robot}>
            <img src={size === 1 ? robot : robot2x} alt="robot" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
